export const BillingCalculationsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Компания',
        key: 'company',
    },
    {
        name: '№ Накладной',
        key: 'invoiceNumber',
    },
    {
        name: 'Тариф',
        key: 'tariff',
    },
    {
        name: 'Сумма платежа к оплате',
        key: 'finalPaymentAmount',
    },
]
